import { z } from 'zod';

const BADGE_TYPE = ['transparency', 'data'] as const;

const badgeSchema = z.object({
    badgeType: z.enum(BADGE_TYPE),
    isVisible: z.boolean(),
    url: z.string(),
    imageUrl: z.string(),
    altText: z.string(),
});

export const badgeContainerSchema = z.object({
    position: z.number(),
    offset: z.number(),
    badges: z.array(badgeSchema),
});

export type BadgeContainer = z.infer<typeof badgeContainerSchema>;
export type Badge = z.infer<typeof badgeSchema>;
